"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const properties_1 = require("@geome/react-components-next/lib/components/properties");
const shell_locator_icons_1 = __importDefault(require("@geome/shell-locator-icons"));
const Features = ({ location }) => ((0, jsx_runtime_1.jsx)(properties_1.PropertiesSection, { configPath: "station_page.", sectionName: "features", countryCode: location.country_code, icons: shell_locator_icons_1.default, location: location, renderNullIfEmpty: true }));
exports.Features = Features;
